var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { orderWiseProductsData, draftOrderDetails, refundOrderData } from "../../../reduxStore/actions/salesRepDataAction";
import { resolveRefundOrderDetailRequestParams } from "../../model/stOrderDetailsRefundGrid";
import { ALL_ORDERS_ROW_DRAFT_LIKE_STATUSES, ALL_ORDERS_ROW_PAID_LIKE_STATUSES, ALL_ORDERS_ROW_REFUND_FINANCIAL_STATUSES, OrderRowDetailKind, StandardOrderMoreActionsMode, } from "../../Constant";
export { OrderRowDetailKind, StandardOrderMoreActionsMode, StandardMobileLineItemsVariant } from "../../Constant";
function normalizeOrderStatus(order) {
    if ((order === null || order === void 0 ? void 0 : order.OrderStatus) == null) {
        return "";
    }
    return String(order.OrderStatus).toLowerCase();
}
function isRefundedTabRow(order, status) {
    return (order === null || order === void 0 ? void 0 : order.isRefundedOrders) === true && ALL_ORDERS_ROW_REFUND_FINANCIAL_STATUSES.includes(status);
}
function isPaidLikeOrder(order, status) {
    return !isRefundedTabRow(order, status) && ALL_ORDERS_ROW_PAID_LIKE_STATUSES.includes(status);
}
function isDraftLikeOrder(order, status) {
    return (!isRefundedTabRow(order, status) &&
        !isPaidLikeOrder(order, status) &&
        ALL_ORDERS_ROW_DRAFT_LIKE_STATUSES.includes(status));
}
export function getStandardOrderMoreActionsMode(order) {
    try {
        if (!order) {
            return StandardOrderMoreActionsMode.None;
        }
        var status_1 = normalizeOrderStatus(order);
        if (isRefundedTabRow(order, status_1)) {
            return StandardOrderMoreActionsMode.None;
        }
        if (status_1 === "pending") {
            return StandardOrderMoreActionsMode.Unpaid;
        }
        if (ALL_ORDERS_ROW_PAID_LIKE_STATUSES.includes(status_1)) {
            return StandardOrderMoreActionsMode.Paid;
        }
        return StandardOrderMoreActionsMode.None;
    }
    catch (error) {
        return StandardOrderMoreActionsMode.None;
    }
}
function classifyOrderRowForDetailFetch(order) {
    var status = normalizeOrderStatus(order);
    var isRefundedOrder = isRefundedTabRow(order, status);
    var isDraftOrder = isDraftLikeOrder(order, status);
    return { isRefundedOrder: isRefundedOrder, isDraftOrder: isDraftOrder };
}
/** Load order details for a row on the All tab (same APIs as Paid / Unpaid / Draft / Refunded tabs). */
export function loadMergedOrderRowDetails(order, dispatch) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var _d, isRefundedOrder, isDraftOrder, res, refundParams, refundDataResponse, refundLineItems, saleWiseProducts, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 6, , 7]);
                    if ((order === null || order === void 0 ? void 0 : order.OrderId) == null) {
                        return [2 /*return*/, null];
                    }
                    _d = classifyOrderRowForDetailFetch(order), isRefundedOrder = _d.isRefundedOrder, isDraftOrder = _d.isDraftOrder;
                    if (!isDraftOrder) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(draftOrderDetails({ order_id: order.OrderId }, ""))];
                case 1:
                    res = _e.sent();
                    return [2 /*return*/, {
                            kind: OrderRowDetailKind.Draft,
                            draftOrder: (_a = res === null || res === void 0 ? void 0 : res.draftOrder) !== null && _a !== void 0 ? _a : null,
                            ProductDetails: Array.isArray(res === null || res === void 0 ? void 0 : res.ProductDetails) ? res.ProductDetails : [],
                        }];
                case 2:
                    if (!isRefundedOrder) return [3 /*break*/, 4];
                    refundParams = resolveRefundOrderDetailRequestParams(order);
                    if (!refundParams) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, dispatch(refundOrderData(refundParams))];
                case 3:
                    refundDataResponse = _e.sent();
                    refundLineItems = (_b = refundDataResponse === null || refundDataResponse === void 0 ? void 0 : refundDataResponse.refunds) === null || _b === void 0 ? void 0 : _b.refund_line_items;
                    if (refundLineItems != null && Array.isArray(refundLineItems)) {
                        return [2 /*return*/, { kind: OrderRowDetailKind.Refund, refund_line_items: refundLineItems }];
                    }
                    return [2 /*return*/, null];
                case 4: return [4 /*yield*/, dispatch(orderWiseProductsData({ order_id: order.OrderId }))];
                case 5:
                    saleWiseProducts = _e.sent();
                    return [2 /*return*/, {
                            kind: OrderRowDetailKind.Standard,
                            ProductDetails: Array.isArray(saleWiseProducts === null || saleWiseProducts === void 0 ? void 0 : saleWiseProducts.ProductDetails) ? saleWiseProducts.ProductDetails : [],
                            singleOrderDetailsFromShopify: (_c = saleWiseProducts === null || saleWiseProducts === void 0 ? void 0 : saleWiseProducts.singleOrderDetailsFromShopify) !== null && _c !== void 0 ? _c : null,
                        }];
                case 6:
                    error_1 = _e.sent();
                    return [2 /*return*/, null];
                case 7: return [2 /*return*/];
            }
        });
    });
}
